import styled from "styled-components";
import { TextColorNames } from "@smartsuite/types";

export const StyledThreeDotsMenu = styled.div`
  .menu-line-separator {
    margin-top: 9px;
    margin-bottom: 4px;
  }

  .menu-option {
    color: ${TextColorNames.tertiary};

    &:hover {
      color: ${TextColorNames.primary};
    }

    &__icon {
      margin-right: 10px;
    }
  }
`;
